/** Вариант выбора продукта: id и название (ответ autocompleteProducts). */
export interface ProductOption {
  value: string;
  label: string;
}

/** Пауза после ввода до запроса вариантов поиска продуктов. */
export const PRODUCT_SEARCH_DEBOUNCE_MS = 300;

/**
 * id, названия которых ещё нет в known: только их и стоит спрашивать у
 * сервера. Отсортированы и без повторов, чтобы одинаковый набор давал
 * одинаковые переменные запроса (и попадание в кеш Apollo).
 */
export const missingProductIds = (
  ids: readonly string[],
  known: ReadonlyMap<string, string>
): string[] => [...new Set(ids.filter((id) => !known.has(id)))].sort();

/** known плюс варианты; та же ссылка, если ничего нового не пришло. */
export function mergeProductLabels(
  known: ReadonlyMap<string, string>,
  options: readonly (ProductOption | null | undefined)[]
): ReadonlyMap<string, string> {
  const fresh = options.filter(
    (option): option is ProductOption =>
      Boolean(option) && known.get(option?.value ?? "") !== option?.label
  );
  if (fresh.length === 0) return known;
  const next = new Map(known);
  for (const option of fresh) next.set(option.value, option.label);
  return next;
}

/** Набор id плюс новые; та же ссылка, если новых нет. */
export function addProductIds(
  current: readonly string[],
  ids: readonly string[]
): readonly string[] {
  const missing = ids.filter((id) => !current.includes(id));
  return missing.length === 0 ? current : [...current, ...missing];
}
